<section class="w-100 d-flex flex-column old-style">
  <div class="pt-5 pb-4">
    <a href="https://{{appVariables.WHITELABEL_LINK}}">
      <img class="d-block mx-auto logo" src="assets/img/{{appVariables.WHITELABEL_LOGO}}" alt="{{appVariables.WHITELABEL_BRAND}}"/>
    </a>
  </div>
  <div class="d-flex justify-content-center">
    <form class="p-3 m-0" id="resetForm" name="resetPasswordForm" [formGroup]="form" (ngSubmit)="submitting=true;reset()">
      <h2 class="mb-3 into">Reset your password</h2>

      <div class="form-group">
        <input
          id="forgot-pw-email"
          type="email"
          formControlName="email"
          autocomplete="email"
          class="form-control"
          [ngClass]="{'is-invalid': form.controls.email.touched && form.controls.email.invalid}"
          placeholder="Email"
          />
        <control-messages [control]="form.get('email')"></control-messages>
      </div>
      <p>If your email is valid, reset password link will be sent to this address.</p>
      <button
        id="reset-password-button"
        type="submit"
        class="btn btn-info btn-lg mb-2 w-100"
        [disabled]="form.invalid || submitting"
        angularticsCategory="auth"
        angulartics2On="click"
        angularticsAction="Reset Password"
      >Reset password</button>
      <div class="d-flex flex-nowrap justify-content-start">
        <a
          [routerLink]="[]"
          (click)="onToggle.emit(authStates.login)"
          angularticsCategory="auth"
          angulartics2On="click"
          angularticsAction="Log In Toggle"
        >Login</a>
        <a
          [routerLink]="[]"
          (click)="createAccount()"
          class="ml-auto"
          angularticsCategory="auth"
          angulartics2On="click"
          angularticsAction="Sign Up Toggle"
        >Create an account</a>
      </div>
    </form>
  </div>
</section>
